export default __webpack_public_path__ + "static/media/img7.a8231e38.jpg";